export const CONNECTION_TYPES = {
  CONNECTED: 'CONNECTED',
  INVITE_SENT: 'INVITE_SENT',
  INVITE_RECEIVED: 'INVITE_RECEIVED',
  NOT_CONNECTED: 'NO_RELATION',
}